import axios from 'axios';
import Api_key from './apiconfiguration';

const cache = new Map();
const validKey = key => /^[\w-]{11}$/.test(key);
const shortTitle = name => /#shorts?\b|\bshorts\b|\bvertical\b/i.test(name || '');
const types = ['Clip', 'Behind the Scenes', 'Featurette', 'Teaser', 'Trailer'];
export function rankMovieClips(videos = []) {
  const seen = new Set();
  return videos.filter(video => video.site === 'YouTube' && validKey(video.key) && (shortTitle(video.name) || types.includes(video.type)))
    .sort((a, b) => Number(shortTitle(b.name)) - Number(shortTitle(a.name)) || types.indexOf(a.type) - types.indexOf(b.type) || Number(!!b.official) - Number(!!a.official))
    .filter(video => { if (seen.has(video.key)) return false; seen.add(video.key); return true; })
    .map(video => ({ ...video, label: shortTitle(video.name) ? 'Short' : video.type, vertical: shortTitle(video.name) }));
}
export async function getMovieClips(movie, signal) {
  const key = `${movie.id}:${movie.title}`;
  if (cache.has(key)) return cache.get(key);
  const youtubeKey = process.env.REACT_APP_YOUTUBE_API_KEY;
  const requests = [axios.get(`https://api.themoviedb.org/3/movie/${movie.id}/videos`, { params: { api_key: Api_key, language: 'en-US' }, signal, timeout: 12000 })];
  if (youtubeKey) requests.push(axios.get('https://www.googleapis.com/youtube/v3/search', {
    params: { key: youtubeKey, part: 'snippet', type: 'video', q: `"${movie.title}" ${movie.release_date?.slice(0, 4) || ''} #shorts`, videoDuration: 'short', videoEmbeddable: 'true', videoSyndicated: 'true', safeSearch: 'strict', maxResults: 8 }, signal, timeout: 12000,
  }));
  const [tmdb, youtube] = await Promise.allSettled(requests);
  if (signal?.aborted) throw new Error('Cancelled');
  const related = youtube?.status === 'fulfilled' ? (youtube.value.data.items || [])
    .filter(item => shortTitle(item.snippet?.title) || shortTitle(item.snippet?.description))
    .map(item => ({ site: 'YouTube', key: item.id?.videoId, name: item.snippet.title, type: 'Clip', label: 'Related short', vertical: true }))
    .filter(item => validKey(item.key)) : [];
  const linked = rankMovieClips(tmdb.status === 'fulfilled' ? tmdb.value.data.results : []);
  const clips = [...related, ...linked.filter(item => !related.some(short => short.key === item.key))];
  if (!clips.length && tmdb.status === 'rejected') throw new Error('Clips unavailable');
  if (tmdb.status === 'fulfilled' && (!youtube || youtube.status === 'fulfilled')) {
    if (cache.size >= 100) cache.delete(cache.keys().next().value);
    cache.set(key, clips);
  }
  return clips;
}
